import { route } from "../../../../shim/jsbridge";
import { Heatmap, Matrix, Region } from "../../@types/visualization";
import { htmlEncode } from "../../util";
import { SVG_PARAMS } from "./consts";

export const checkForErrorMessage = (
  hasPlot: boolean,
  hasRanges: boolean,
  sha1: string
) => {
  if (!hasPlot) {
    return `Failed to generate structure plot for file ${sha1}`;
  }
  if (!hasRanges) {
    return "File Visualization is not available at this time";
  }
  return null;
};

const getRoute = (
  hash: string,
  sourceId?: number,
  section?: string,
  qp?: Record<string, number | undefined>
) => {
  if (!sourceId) {
    return route("redirect_samples_details_section", [hash, section], qp);
  }
  return route("samples_details_section", [hash, sourceId, section], qp);
};

export const mapActiveElements = (
  type: "region" | "entropy" | "entries",
  matrix?: Matrix
) => {
  const allBlocks = [...(matrix?.blocks || []), ...(matrix?.extras || [])];

  return allBlocks.reduce<Record<string, boolean>>((activeElements, block) => {
    // eslint-disable-next-line no-param-reassign
    activeElements[block[type]] = true;
    return activeElements;
  }, {});
};

export const regionMachineName = (element: Region) =>
  htmlEncode(element.name.toLowerCase().replace(/\s/g, "-"));

export const calculateSvgHeight = (blocks: string, extras?: string) => {
  const extrasCount = extras ? parseInt(extras, 10) : 0;
  const rowNumbers =
    Math.ceil((parseInt(blocks, 10) + extrasCount) / SVG_PARAMS.pColumns) + 1;
  return rowNumbers * SVG_PARAMS.blockSize;
};

export const defineRegionStyles = (regions: Array<Region>) =>
  regions.reduce((acc, curr) => {
    const machineName = regionMachineName(curr);
    acc[curr.style] = {
      id: curr.style,
      name: curr.name,
      machine: machineName
    };
    return acc;
  }, {} as Record<string, { id: string; name: string; machine: string }>);

export const defineHeatmapStyles = (heatmaps: Array<Heatmap>) =>
  heatmaps.reduce((acc, curr: Heatmap) => {
    const machineName = `entropy-${curr.style}`;
    acc[curr.style] = {
      id: curr.style,
      name: curr.name,
      machine: machineName
    };
    return acc;
  }, {} as Record<string, { id: string; name: string; machine: string }>);

export const generateRegionLinks = (
  sha1: string,
  sourceId?: number,
  relationshipId?: number
) => {
  const queryObject = relationshipId ? { r: relationshipId } : {};
  return {
    "resource-table": getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/resources",
      queryObject
    ),
    "import-table": getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/imports",
      queryObject
    ),
    overlay: getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/overlay",
      queryObject
    ),
    "pe-header": getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/optional_header",
      queryObject
    ),
    header: getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/optional_header",
      queryObject
    ),
    "export-table": getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/exports",
      queryObject
    ),
    sections: getRoute(
      sha1,
      sourceId,
      "ticore/application/pe/sections",
      queryObject
    )
  };
};
